<template>
  <div class="float-right">
    <v-btn
      icon
      large
      @click="fileBtnClick"
    >
      <v-icon color="deep-orange lighten-2">
        {{ mdiFileDocument }}
      </v-icon>
    </v-btn>

    <!-- <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-list>
        <v-list-item @click="dialog = false; $emit('previewOficioFile')">
          <v-list-item-content>
            <v-list-item-title>{{ $t('Outbox.PreviewUploadFile') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="dialog = false; $emit('previewRefFile')">
          <v-list-item-content>
            <v-list-item-title>{{ $t('Outbox.PreviewRefDoc') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-dialog> -->
  </div>
</template>

<script>
import { mdiFileDocument } from '@mdi/js'

export default {
  props: {
    hasRefFile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mdiFileDocument: mdiFileDocument
      // dialog: false
    }
  },
  methods: {
    fileBtnClick () {
      // if (this.hasRefFile) {
      //   this.dialog = true
      // } else {
      //   this.dialog = false
      //   this.$emit('previewFile')
      // }
      this.$emit('previewFile')
    }
  }
}
</script>
